/**
 * Builds the {@link AppHeader} `onHomeIntercept` guard for leaving an active game
 * (FR-9.8 / D-F8.2). When `active`, clicking the home link prompts a confirm and
 * cancels navigation if the user dismisses it; when not active it returns `undefined`
 * so navigation is immediate.
 *
 * This is a UX guard only: the WS reconnect model retains the player seat and the
 * host session regardless (FR-9.3/FR-2.6), so `message` should reassure ("your seat
 * is kept") rather than warn of loss.
 */
export function homeGuard(active: boolean, message: string): (() => boolean) | undefined {
  if (!active) return undefined;
  return () => window.confirm(message);
}
